import { validateActionKeyupForm, validateFormFields, validateFormFieldsHubspot } from './ModValidateForm'
/* eslint-disable */
class ModSendMail {
  constructor() {
    this.$this = $('.mod-form-calculator,.mod-new-calculator');
    this.loadingMoreStar = '.loading-more-star';
    this.responseMessage = '.response-message';
    this.hsForm = '.hs-form';
    this.btnSendMailPdfHubspot = '.btn-send-mail-pdf-hubspot';
    this.wrapHbS = '.wrap-hbspt-form';
    this.formHB = 'form-group-hbspt';
    this.isNewCalculator = this.$this.hasClass('mod-new-calculator');
    this.frmCalcultor = '#frm-calcultor';
    this.initEles();
    this.init();
  }

  sendMailPdfSuccess(response) {
    if (response.data.status === 1) {
      const message = response.data.content;
      let $success = $('.popup-show').find('.headline-hbspt');
      if (this.$this.hasClass('capex-calculator')) {
        $('#user_mail').addClass('hidden');
        $('.btn-send-mail-pdf-capex').addClass('hidden');
        $success = $(this.responseMessage);
      }
      if (this.$this.hasClass('hubspot-calculator')) {
        $(this.btnSendMailPdfHubspot).addClass('hidden');
        $(this.wrapHbS).addClass('hidden');
        $success = $(this.responseMessage);
        if ($(`.${this.formHB}`).length) {
          $(`.${this.formHB}`).removeClass(this.formHB);
        }
      }
      if (response.data.valid) {
        $success.html(message);
      } else {
        $('.message-captcha-error').remove();
        $success.append(`<div class="message-captcha-error">${message}</div>`);
      }
    }
  }

  initEles() {
    this.$userMail = $('#user-mail');
    if (this.isNewCalculator) {
      this.$annualElectricUtility = this.$this.find('#annualElectricUtility');
      this.$annualMaintenanceCost = this.$this.find('#annualMaintenanceCost');
      this.$annualTaxesInsurance = this.$this.find('#annualTaxesInsurance');
      this.$estimatedAnnualOperating = this.$this.find('#estimatedAnnualOperating');
      this.$equivalentSTACK = this.$this.find('#equivalentSTACK');
      this.$annualCostSavings = this.$this.find('#annualCostSavings');
    } else {
      this.$annualMaintenanceCost = this.$this.find('#annual-maintenance-cost');
      this.$annualTaxesInsurance = this.$this.find('#annual-taxes-insurance');
      this.$yearCapExForecast2 = this.$this.find('#year-capEx-forecast-2');
      this.$yearCapExForecast5 = this.$this.find('#year-capEx-forecast-5');
      this.$yearCapExForecast10 = this.$this.find('#year-capEx-forecast-10');
    }
  }

  getSendMailData($formSubmit, typeForm) {
    let userMail = $formSubmit.find('#user_mail').val();
    if (typeForm === 'gated_calculator') {
      userMail = $('.hbspt-email').text();
      $('.btn-send-mail-pdf-hubspot').addClass('hidden');
    }
    const resultObj = {
      action: this.isNewCalculator ? 'sta_send_mail_new_calculator_pdf' : 'sta_send_mail_calculator_pdf',
      action_validate: 'form_send_mail_pdf',
      token: $formSubmit.find('input[name="token"]').val(),
      user_mail: userMail,
      type: typeForm,
      is_new_calculator: this.isNewCalculator,
      firstname: $('.hbspt-firstname').text(),
      data: $(this.frmCalcultor).serializeArray()
    };
    if (this.isNewCalculator) {
      resultObj.annual_electric_utility = this.$annualElectricUtility.text();
      resultObj.annual_main_cost = this.$annualMaintenanceCost.text();
      resultObj.annual_tax_insu = this.$annualTaxesInsurance.text();
      resultObj.estimated_annual_operating = this.$estimatedAnnualOperating.text();
      resultObj.equivalent_stack = this.$equivalentSTACK.text();
      resultObj.annual_cost_savings = this.$annualCostSavings.text();
    } else {
      resultObj.annual_main_cost = this.$annualMaintenanceCost.text();
      resultObj.annual_tax_insu = this.$annualTaxesInsurance.text();
      resultObj.two_year_capex = this.$yearCapExForecast2.text();
      resultObj.five_year_capex = this.$yearCapExForecast5.text();
      resultObj.ten_year_capex = this.$yearCapExForecast10.text();
    }
    return resultObj;
  }

  submitSendMailPdf($object, $formSubmit, $loading, typeForm) {
    $loading.removeClass('hidden');
    if (typeForm === 'non_gated_calculator') {
      window.refreshToken = false;
      this.generateCaptchaForm(this.$this);
      const inter = setInterval(() => {
        if (window.refreshToken === true) {
          clearTimeout(inter);
          this.handleAfterSubmit($object, $formSubmit, $loading, typeForm);
        }
      }, 30);
    } else {
      this.handleAfterSubmit($object, $formSubmit, $loading, typeForm);
    }
  }

  handleAfterSubmit($object, $formSubmit, $loading, typeForm) {
    const postingSendMailPdf = $.post(window.AJAX_URL, this.getSendMailData($formSubmit, typeForm));
    postingSendMailPdf.done((response) => {
      $object.removeClass('hidden');
      this.sendMailPdfSuccess(response);
      $object.data('isClick', false);
      $loading.addClass('hidden');
    });
  }

  isValidForm($object) {
    let hasValidate = true;
    const itemErrors = $object.find('.error');
    if (itemErrors.length > 0) {
      hasValidate = false;
      $object.find('.error').first().focus();
    }
    return hasValidate;
  }

  createCaptchaToken($form, siteKey) {
    grecaptcha.ready(() => {
      grecaptcha.execute(siteKey, { action: 'form_send_mail_pdf' }).then((token) => {
        $form.find('input[name="token"]').val(token);
        window.refreshToken = true;
      });
    });
  }

  generateCaptchaForm($popupShow) {
    const me = this;
    const siteKey = $popupShow.find('input[name="site_key"]').val();
    if (window.recaptcha !== undefined) {
      me.createCaptchaToken($popupShow.find('form'), siteKey);
    } else {
      const script = document.createElement('script');
      script.setAttribute('nonce', 'oNlhcyWi5r');
      script.src = $popupShow.find('.capcha-popup').attr('data-recaptcha');
      document.getElementsByTagName('head')[0].appendChild(script);
      const inter = setInterval(() => {
        if (window.recaptcha !== undefined) {
          clearTimeout(inter);
          me.createCaptchaToken($popupShow.find('form'), siteKey);
        }
      }, 30);
    }
  }

  init() {
    const me = this;
    $('.print-pdf').find('a').on('click', () => {
      setTimeout(() => {
        const $popupShow = $('.mod-popup.popup-show');
        const btnSendMailPdf = $popupShow.find('.btn-outline-primary');
        me.generateCaptchaForm($popupShow);
        btnSendMailPdf.unbind('click').on('click', (e) => {
          e.preventDefault();
          $(e.currentTarget).data('isCheckValidate', true);
          const $formSubmit = $(e.currentTarget).closest('form');
          const $loading = $popupShow.find(me.loadingMoreStar);
          validateFormFields($formSubmit);
          const validate = me.isValidForm($formSubmit);
          if (validate) {
            const isClick = $(e.currentTarget).data('isClick');
            if (isClick === undefined || isClick === null || isClick === false) {
              $(e.currentTarget).data('isClick', true);
              me.submitSendMailPdf($(e.currentTarget), $formSubmit, $loading, 'calculator');
            }
          }
        });

        $(document).on('submit', 'form', (e) => {
          e.preventDefault();
          return false;
        });
        btnSendMailPdf.data('isCheckValidate', false);
        validateActionKeyupForm($popupShow.find('form'), btnSendMailPdf);
      }, 200);
    });
  }

  capexInit() {
    const me = this;
    const btnSendMailPdfCapex = $('.btn-send-mail-pdf-capex');
    me.generateCaptchaForm(this.$this);
    btnSendMailPdfCapex.unbind('click').on('click', (e) => {
      e.preventDefault();
      $(me.responseMessage).html('');
      $(e.currentTarget).data('isCheckValidate', true);
      const $formSubmit = $(e.currentTarget).closest('form');
      const $loading = $formSubmit.find(me.loadingMoreStar);
      validateFormFields($formSubmit);
      const validate = me.isValidForm($formSubmit);
      if (validate) {
        const isClick = $(e.currentTarget).data('isClick');
        if (isClick === undefined || isClick === null || isClick === false) {
          $(e.currentTarget).data('isClick', true);
          $(e.currentTarget).addClass('hidden');
          me.submitSendMailPdf($(e.currentTarget), $formSubmit, $loading, 'non_gated_calculator');
        }
      }
    });
    $(document).on('submit', 'form', (e) => {
      e.preventDefault();
      return false;
    });
    btnSendMailPdfCapex.data('isCheckValidate', false);
    validateActionKeyupForm($(this.frmCalcultor), btnSendMailPdfCapex);
  }

  hubspotInit() {
    const me = this;
    const sendMailPdfHubspot = $(this.btnSendMailPdfHubspot);
    const $formSubmit = $(this.frmCalcultor);
    sendMailPdfHubspot.unbind('click').on('click', (e) => {
      e.preventDefault();
      $(me.responseMessage).html('');
      $(e.currentTarget).data('isCheckValidate', true);
      validateFormFieldsHubspot($formSubmit);
      const validate = me.isValidForm($formSubmit);
      if (validate) {
        $('.hbspt-email').text($(me.hsForm).find('input[name="email"]').val());
        $('.hbspt-firstname').text($(me.hsForm).find('input[name="firstname"]').val());
        $(me.hsForm).find('.hs-button').trigger('click');
      }
    });
    $(document).on('submit', 'form', (e) => {
      e.preventDefault();
      return false;
    });
    sendMailPdfHubspot.data('isCheckValidate', false);
    const inter = setInterval(() => {
      if ($(me.hsForm).length) {
        clearTimeout(inter);
        validateActionKeyupForm($formSubmit, sendMailPdfHubspot);
      }
    }, 30);
  }
}

const hubspotAfterSubmited = () => {
  const sendMail = new ModSendMail();
  const sendMailPdfHubspot = $(sendMail.btnSendMailPdfHubspot);
  const $formSubmit = $(sendMail.hsForm);
  const $loading = $(sendMail.loadingMoreStar);
  sendMail.submitSendMailPdf(sendMailPdfHubspot, $formSubmit, $loading, 'gated_calculator');
}

const SendMailPdf = (() => {
  const modForms = '.mod-form-calculator,.mod-new-calculator';
  if ($(modForms).length) {
    new ModSendMail();
  }
  if ($(modForms).hasClass('capex-calculator')) {
    new ModSendMail().capexInit();
  }
  if ($(modForms).hasClass('hubspot-calculator')) {
    new ModSendMail().hubspotInit();
    window.hubspotAfterSubmited = hubspotAfterSubmited;
  }
})();

export default SendMailPdf;